// Espelha a regra de compensação do cálculo de ponto (CompensacaoHorasRegra no mbs-api).
export const CREDITOS_COMPENSACAO = [
  "EXTRA50",
  "EXTRA60",
  "EXTRA70",
  "EXTRA100",
  "EXTRA50BANCOHORAS",
];

export const DEBITOS_COMPENSACAO = ["COMPENSAR", "ATRASO"];

// Ordem aplicada pela compensação padrão do sistema.
export const CREDITOS_PADRAO = ["EXTRA50", "EXTRA60", "EXTRA50BANCOHORAS"];
export const DEBITOS_PADRAO = ["COMPENSAR", "ATRASO"];

export const MODOS_COMPENSACAO = {
  DESATIVADA: "DESATIVADA",
  PADRAO: "PADRAO",
  PERSONALIZADA: "PERSONALIZADA",
};

export function normalizarTipos(tipos, permitidos) {
  const normalizados = [];
  (Array.isArray(tipos) ? tipos : []).forEach((tipo) => {
    if (permitidos.includes(tipo) && !normalizados.includes(tipo)) {
      normalizados.push(tipo);
    }
  });
  return normalizados;
}

// Mesma leitura do cálculo: a última parametrização do tipo prevalece.
export function parametrizacaoAtiva(parametrizacoes, tipo, padrao = false) {
  let ativo = padrao;
  (Array.isArray(parametrizacoes) ? parametrizacoes : []).forEach((item) => {
    if (item && item.tipo === tipo) {
      ativo = item.ativo === true;
    }
  });
  return ativo;
}

export function modoCompensacao(sindicato) {
  if (
    !parametrizacaoAtiva(sindicato?.parametrizacoes, "COMPENSARHORAS", true)
  ) {
    return MODOS_COMPENSACAO.DESATIVADA;
  }
  return sindicato?.compensacaoPersonalizada === true
    ? MODOS_COMPENSACAO.PERSONALIZADA
    : MODOS_COMPENSACAO.PADRAO;
}

export function regraCompensacao(sindicato) {
  if (modoCompensacao(sindicato) === MODOS_COMPENSACAO.PERSONALIZADA) {
    return {
      creditos: normalizarTipos(
        sindicato.compensacaoCreditos,
        CREDITOS_COMPENSACAO
      ),
      debitos: normalizarTipos(
        sindicato.compensacaoDebitos,
        DEBITOS_COMPENSACAO
      ),
    };
  }
  return { creditos: [...CREDITOS_PADRAO], debitos: [...DEBITOS_PADRAO] };
}

// Cada crédito, na ordem, abate os débitos na ordem até se esgotar. Valores em minutos.
export function simularCompensacao({
  creditos = [],
  debitos = [],
  saldos = {},
  compensarAtraso = true,
}) {
  const resultado = {};
  Object.keys(saldos).forEach((tipo) => {
    resultado[tipo] = Math.max(0, Number(saldos[tipo]) || 0);
  });
  const movimentos = [];

  creditos.forEach((credito) => {
    debitos.forEach((debito) => {
      if (!compensarAtraso && debito === "ATRASO") {
        return;
      }
      const horas = Math.min(resultado[credito] || 0, resultado[debito] || 0);
      if (horas > 0) {
        resultado[credito] -= horas;
        resultado[debito] -= horas;
        movimentos.push({ credito, debito, horas });
      }
    });
  });

  return { saldos: resultado, movimentos };
}

// Aceita "2:30", "02:30" ou horas decimais ("2,5" / "2.5"). Retorna minutos ou null.
export function parseHoras(valor) {
  const texto = String(valor ?? "").trim();
  if (!texto) {
    return null;
  }
  const horario = texto.match(/^(\d{1,3}):(\d{1,2})$/);
  if (horario) {
    const minutos = Number(horario[2]);
    return minutos < 60 ? Number(horario[1]) * 60 + minutos : null;
  }
  if (/^\d{1,3}([.,]\d+)?$/.test(texto)) {
    return Math.round(Number(texto.replace(",", ".")) * 60);
  }
  return null;
}

export function formatarHoras(minutos) {
  const total = Math.max(0, Math.round(Number(minutos) || 0));
  const horas = Math.floor(total / 60);
  const resto = total % 60;
  return `${String(horas).padStart(2, "0")}:${String(resto).padStart(2, "0")}`;
}
